import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/AboutComponents/AboutComponent.tsx");
